import VIEW_ACCESS_TEMPLATE from "../components/modules/dynamic-views/view-management/config/view-access.template";

const NOT_FOUND_PATH = "/not-found";
const VIEW_MANAGEMENT_BASE_PATH = "/";

export default class ViewAccessService {
  getViewConfig(viewName) {
    return VIEW_ACCESS_TEMPLATE[viewName];
  }

  isValidViewName(viewName) {
    return Boolean(this.getViewConfig(viewName));
  }

  hasPermissionForView(viewName, userPermissions = []) {
    const viewConfig = this.getViewConfig(viewName);

    if (!viewConfig) {
      return false;
    }

    const requiredPermission = viewConfig.permission;
    if (!requiredPermission) {
      return true;
    }

    return userPermissions.includes(requiredPermission);
  }

  canAccessView(viewName, userPermissions = []) {
    return this.isValidViewName(viewName) && this.hasPermissionForView(viewName, userPermissions);
  }

  buildViewPath(viewName, id) {
    const viewConfig = this.getViewConfig(viewName);
    const route = viewConfig?.route ?? `${VIEW_MANAGEMENT_BASE_PATH}/${viewName}`;
    const subRoute = viewConfig?.subRoute ?? "";
    return `${route}/${id}${subRoute}`;
  }

  getNotFoundPath() {
    return NOT_FOUND_PATH;
  }
}
